import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BudgetPage from './components/BudgetPage';

const BudgetPageFunction = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Budget Control and Report</h3>
      </Col>
    </Row>
    <Row>
      <BudgetPage />
    </Row>
  </Container>
);

export default BudgetPageFunction;
